/// Port of mobile/lib/game/game_state.dart.

export type GameStatus = 'waiting' | 'playing' | 'paused' | 'gameOver';

export interface GameState {
  status: GameStatus;
  distanceTraveled: number;
  currentScore: number;
  highScore: number;
  lives: number;
}

export function createGameState(overrides: Partial<GameState> = {}): GameState {
  return {
    status: 'waiting',
    distanceTraveled: 0.0,
    currentScore: 0,
    highScore: 0,
    lives: 1,
    ...overrides,
  };
}

export function isDead(state: GameState): boolean {
  return state.lives <= 0;
}
